import React from 'react';
import { SectionPanel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { TileWrapper } from 'app/components/tile-wrapper/tile-wrapper';
import { CompanyReportSectionType } from '../metroline/types';
import { EmailSettingsProps } from '../types';
import { EmailSettingsGroup } from './email-settings-group';
import { EmailSettingsReport } from './email-settings-report';
import styles from './email-settings.scss';

export const EmailSettings: React.FC<EmailSettingsProps> = (props) => {
  const { translation, section, getRef, shouldRenderSection } = props;

  return <MetroLineSection<CompanyReportSectionType>
    section={section}
    sectionType={CompanyReportSectionType.EmailSettings}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(CompanyReportSectionType.EmailSettings)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={CompanyReportSectionType.EmailSettings}
        validation={undefined}
        info={{ text: translation.email_settings }}
        label={{ visible: true, text: translation.email_settings }} />
      <MainGridContainer>
        <EmailSettingsReport {...props} />
        <TileWrapper>
          <div className={styles.container}>
            <EmailSettingsGroup {...props} />
          </div>
        </TileWrapper>
      </MainGridContainer>
    </div>
  </MetroLineSection >;
};
